import { withTheme } from 'styled-components'

export const IconCheckPlain = withTheme(({ theme, ...props }) => (
	<svg {...props} viewBox='0 0 24 24' fill='currentcolor' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M11.662 15.8214L18.7072 8.71916C19.0976 8.32528 19.0976 7.68777 18.7072 7.29389C18.3158 6.90204 17.6822 6.90204 17.2928 7.29389L10.2477 14.3971L6.70867 10.8294C6.31625 10.4376 5.68372 10.4376 5.29432 10.8294C4.90189 11.2223 4.90189 11.8598 5.29432 12.2547L8.83433 15.8214L9.5405 16.533C9.93192 16.9269 10.5644 16.9269 10.9548 16.533L11.662 15.8214Z'
		/>
	</svg>
))
